import { Component, inject, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router, RouterModule } from '@angular/router';
import { AuthService } from '../../services/auth.service';
import { SystemMonitorService } from '../../services/system-monitor.service';
import { LucideAngularModule, Layers, Activity, ChevronRight, ChevronLeft, Settings, Cpu, MemoryStick, FileUp, Copy, Factory } from 'lucide-angular';

@Component({
    selector: 'app-layout',
    standalone: true,
    imports: [CommonModule, RouterModule, LucideAngularModule],
    templateUrl: './layout.component.html',
    styleUrls: ['./layout.component.css']
})
export class LayoutComponent {
    authService = inject(AuthService);
    systemMonitorService = inject(SystemMonitorService);
    router = inject(Router);

    readonly icons = { Layers, Activity, ChevronRight, ChevronLeft, Settings, Cpu, MemoryStick, FileUp, Copy, Factory };

    isSidebarExpanded = signal<boolean>(false);

    toggleSidebar() {
        this.isSidebarExpanded.update(v => !v);
    }

    logout() {
        this.authService.logout();
        this.router.navigate(['/login']);
    }

    isActive(route: string): boolean {
        return this.router.isActive(route, { paths: 'exact', queryParams: 'ignored', fragment: 'ignored', matrixParams: 'ignored' });
    }

    getDashOffset(percentage: number, circumference: number): number {
        return circumference - (percentage / 100) * circumference;
    }
}
